<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router'
import { useModalStore } from '@/stores/modal.js';
import PasswordRequirements from "@/components/password_requirements.vue";

// Stores
const modalStore = useModalStore();

// I18n
const { t } = useI18n();

// Variables
const isLoading = ref(true);
const isVerificationSuccessful = ref(false);
const router = useRouter();
const password = ref("");
const passwordConfirmation = ref("");
const tokenParam = ref(new URLSearchParams(window.location.search).get('token'));
const passwordValid = ref(false);

const resetPassword = () => {
    fetch(`${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/users/update_user_password_from_reset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: password.value, password_confirmation: passwordConfirmation.value, reset_password_token: tokenParam.value })
    })
    .then(response => {
        if (response.ok) {
            modalStore.setModal(modalStore.modalTypeConstants.LOGIN);
            router.push({ path: '/' });
        } else {
            isLoading.value = false;
        }
    })
    .catch(error => {
        console.error('Error:', error);
        isLoading.value = false;
    });
};

const isFormValid = computed(() => {
      return (
        passwordValid &&
        passwordConfirmation.value &&
        password.value === passwordConfirmation.value
      );
    });
</script>

<template>
    <div class="mt-10 mb-10 flex justify-center items-center w-full">
        <div class="max-w-fit">
            <PasswordRequirements :password="password" :password_confirmation="passwordConfirmation" :password_confirmation_required="true" @allValid="(value) => passwordValid = value" />

            <div class="mb-2">
                <label for="code" class="block text-gray-600 font-semibold">{{ t('modal.sign_up.password_label') }}</label>
                <input type="password" id="code" name="code" v-model="password" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t('modal.sign_up.password_placeholder')">
            </div>
            <div class="mb-2">
                <label for="code" class="block text-gray-600 font-semibold">{{ t('modal.sign_up.password_confirmation_label') }}</label>
                <input type="password" id="code" name="code" v-model="passwordConfirmation" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t('modal.sign_up.password_confirmation_placeholder')">
            </div>
            <button type="button" :disabled="isFormValid == false" class="w-full text-white py-2 px-4 font-semibold bg-green-500 rounded-full hover:opacity-75" @click="resetPassword">{{ t('password_reset.submit') }}</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>
